import React, { useState, useEffect } from "react";
import { MSG } from "../constants/toastMessages";
import { apiCallingPost } from '../api/services';
import Logo from "../assets/images/logo.webp"
import { useLocation, useNavigate} from "react-router-dom";
import { toast } from 'react-toastify';
import { MdVisibility, MdVisibilityOff } from 'react-icons/md';
function ResetPassword() {
    const location = useLocation();
    const navigate = useNavigate();
    const [password, setPassword] = useState("")
    const [confirmPassword, setConfirmPassword] = useState("")    
    const [token, setToken] = useState("")
    const [isExpired, setIsExpired] = useState(false)
    const [saveFlag, setSaveFlag] = useState(false);
    const [showPassword, setShowPassword] = useState(false);
    useEffect(() => {
        const queryParams = new URLSearchParams(location.search);
        const token = queryParams.get("token"); // 👈 Correct param name
        setToken(token); // retained so the reset submit can prove possession of the link
        verifyResetToken(token); // pass the token to your verification function
    }, [location.search]);

    const verifyResetToken = async (token) => {
        let postData = {
            token
        }
        const response = await apiCallingPost("api/authentication/verifyResetToken", postData);
        const { data } = response;
        // Only used to show the "link expired" state up front; the actual reset is
        // authorized by the token itself (sent to resetPassword), not by these values.
        if(data.success !== "1"){
            setIsExpired(true)
        }
    }
    const resetPassword = async () => {
        if(password === ""){
            toast.error(MSG.passwordRequired);
        }
        else if(confirmPassword === ""){
            toast.error(MSG.confirmPasswordRequired);
        }
        else if(password !== confirmPassword){
            toast.error(MSG.passwordMismatch);
        }
        else{
            setSaveFlag(true);
            // The reset token (from the email link) authorizes the reset; the BE
            // derives the user + idp id from it, so we no longer send userId/idpUserId.
            let postData = {
                token,
                password
            }
            const response = await apiCallingPost("api/authentication/resetPassword", postData);
            const { data } = response;
            if(data.success === "1"){
                toast.success(MSG.passwordUpdated)
                setTimeout(() => {
                    navigate("/login");
                    setSaveFlag(false)
                }, 3000);
            }
            else{
                toast.error(MSG.couldNotProcess);
            }
        }        
    }

    return (
        <div className="modal-admin-wrapper popup-outer-div">
            <div className="p-4">
                <a className='login_logo' href="/">
                    <img src={Logo} alt="Logo" className="img-fluid logo-change" width="120" height="50" />
                </a>
            </div>

            {isExpired === false ?
                    <div className="modal-ad-popup modal-md">
                        <div className="modal-innerpopup ">
                            <div className="modal-headdiv d-flex justify-content-between">
                                <h5 className="modal-head">Reset Password</h5>
                            </div>
                            <div className="modal-admin-body my-3" style={{ maxHeight: 'calc(100vh - 290px)' }}>
                                <div className="modal-admin-body">
                                    <div className="form_div" style={{ position: 'relative' }}>
                                        <input
                                            type={showPassword ? 'text' : 'password'}
                                            id="password"
                                            placeholder="Password"
                                            aria-label="New password"
                                            autoComplete="new-password"
                                            value={password}
                                            onChange={(e) => setPassword(e.target.value)}
                                            className="form-register-popup"
                                        />
                                        <span
                                            onClick={() => setShowPassword((s) => !s)}
                                            role="button"
                                            aria-label={showPassword ? 'Hide password' : 'Show password'}
                                            title={showPassword ? 'Hide password' : 'Show password'}
                                            style={{ position: 'absolute', right: 14, top: 'calc(50% - 5.5px)', transform: 'translateY(-50%)', cursor: 'pointer', color: '#666', display: 'flex' }}
                                        >
                                            {showPassword ? <MdVisibilityOff /> : <MdVisibility />}
                                        </span>
                                    </div>
                                    <div className="form_div">
                                        <input
                                            type={showPassword ? 'text' : 'password'}
                                            id="confirmPassword"
                                            placeholder="Confirm Password"
                                            aria-label="Confirm new password"
                                            autoComplete="new-password"
                                            value={confirmPassword}
                                            onChange={(e) => setConfirmPassword(e.target.value)}
                                            className="form-register-popup"
                                        />
                                    </div>
                                </div>
                            </div>
                            <div className="tag-popup-footer">
                                <div className="d-flex align-items-center gap-2">
                                    <button
                                        type="button"
                                        disabled = {saveFlag}
                                        className="accept-all-btn w-100 py-2 d-flex align-items-center gap-2 justify-content-center"
                                        onClick={() => resetPassword()}
                                    >
                                        Reset Password
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                :
                    <div className="modal-ad-popup modal-md">
                        <div className="modal-innerpopup" style={{color:'red'}}>Your password reset link has expired. Please request a new one to continue.</div>
                    </div>
            }
        </div >
    );
}
export default ResetPassword;